<template>
  <date-time-label
    v-if="isDate && isNotANumber"
    :value="value"
    :format="dateTimeFormat"
    :time-zone="timeZone"
  />
  <span
    v-else-if="isUnformattedNumber"
    v-text="$n(value)"
  />
  <span
    v-else
    v-text="value"
  />
</template>

<script>
import {
  isValid,
} from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

const unformattedNumberMatcher = /^-?\d+(\.\d+)?$/;

export default {
  props: {
    value: null,
    dateTimeFormat: {
      default: () => formats.DATETIME_SHORT_WITH_SECONDS,
      required: false,
      type: [Object, String],
    },
    timeZone: {
      required: false,
      type: String,
    },
  },
  computed: {
    isNotANumber() {
      return !Number(this.value);
    },
    isDate() {
      return isValid(this.value);
    },
    isUnformattedNumber() {
      return unformattedNumberMatcher.test(this.value);
    },
  },
};
</script>
